import { apiGet } from '../../utilities/apiClient';
import { getSessionIds, getStoreState } from './_sessionIds';
import { ADD_RESPONSES, FETCHING_RESPONSES, FETCHED_RESPONSES } from '../constants';

const pendingResponseRequests = new Map<string, object>();

/**
 * Fetch block responses for a project (same as web getResponses).
 * Used to pre-fill survey model with blob data per page; segments supplement for per-question.
 */
export const getResponses = (projectId: string | number, override = false) => async (dispatch: any) => {
  const { accountId, cognitoId } = getSessionIds();
  if (!accountId || !cognitoId) return { success: false };
  const pid = String(projectId);
  const state = getStoreState();
  const requestKey = JSON.stringify([accountId, cognitoId, pid]);
  const request = {};
  const startedAuthorized = state?.session?.authorized;
  const isCurrentScope = () => {
    const current = getStoreState();
    return current?.session?.account?.account_id === accountId
      && current?.authentication?.user?.cognito_id === cognitoId
      && (startedAuthorized !== true || current?.session?.authorized === true)
      && pendingResponseRequests.get(requestKey) === request;
  };
  const responses = state?.responses;
  const alreadyFetched = responses?.accountId === accountId && responses?.cognitoId === cognitoId && responses?.fetched?.[pid];
  if (alreadyFetched && !override) return { success: true };

  pendingResponseRequests.set(requestKey, request);
  dispatch({ type: FETCHING_RESPONSES, payload: true, meta: { accountId, cognitoId } });
  try {
    const res = await apiGet(`/block-responses/get-all/${pid}/${accountId}/${cognitoId}`);
    if (!isCurrentScope()) return { success: false, cancelled: true };
    if (res?.success && Array.isArray(res?.payload)) {
      dispatch({ type: ADD_RESPONSES, payload: { project_id: pid, list: res.payload } });
      dispatch({ type: FETCHED_RESPONSES, payload: { project_id: pid } });
      return { success: true, payload: res.payload };
    }
    dispatch({ type: FETCHED_RESPONSES, payload: { project_id: pid } });
    return { success: false };
  } catch (err: any) {
    if (!isCurrentScope()) return { success: false, cancelled: true };
    dispatch({ type: FETCHED_RESPONSES, payload: { project_id: pid } });
    return { success: false, message: err?.message };
  } finally {
    if (isCurrentScope()) dispatch({ type: FETCHING_RESPONSES, payload: false });
    if (pendingResponseRequests.get(requestKey) === request) pendingResponseRequests.delete(requestKey);
  }
};
